import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import SmoothScroll from "@/components/layout/SmoothScroll";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import ObraDetail from "@/pages/ObraDetail";
import SobreLatir from "@/pages/SobreLatir";
import Agenda from "@/pages/Agenda";
import Reservas from "@/pages/Reservas";
import SobreArteconcienciasv from "@/pages/SobreArteconcienciasv";
import Prensa from "@/pages/Prensa";
import NotFound from "@/pages/NotFound";
import AdminHome from "@/pages/AdminHome";
import AdminVisitas from "@/pages/AdminVisitas";
import AdminDiaPrint from "@/pages/AdminDiaPrint";
import Encuesta from "@/pages/Encuesta";
import AdminObras from "@/pages/AdminObras";
import AdminCatalogo from "@/pages/AdminCatalogo";
import { loadCatalog } from "@/data/catalogLive";

// Hide public Navbar/Footer on admin routes so AdminHeader is the only chrome.
function ChromeSwitcher() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return isAdmin ? null : <Navbar />;
}
function FooterSwitcher() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return isAdmin ? null : <Footer />;
}

// Redirect permanente preservando el hash (#sala-…)
function RedirectWithHash({ to }) {
  const location = useLocation();
  return <Navigate to={{ pathname: to, hash: location.hash }} replace />;
}

function App() {
  // Carga el catálogo vivo desde la DB (una vez por sesión; las páginas
  // consumidoras se re-renderizan solas vía useCatalogVersion).
  useEffect(() => { loadCatalog(); }, []);
  return (
    <LanguageProvider>
      <BrowserRouter>
        <SmoothScroll>
          <div className="paper-grain relative min-h-screen bg-paper">
            <ChromeSwitcher />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/latir" element={<SobreLatir />} />
                <Route path="/sobre-latir" element={<RedirectWithHash to="/latir" />} />
                <Route path="/artistas" element={<Artists />} />
                <Route path="/artistas/:slug" element={<ArtistDetail />} />
                <Route path="/obra/:qrslug" element={<ObraDetail />} />
                <Route path="/programa" element={<Agenda />} />
                <Route path="/agenda" element={<RedirectWithHash to="/programa" />} />
                <Route path="/sobre-arteconcienciasv" element={<SobreArteconcienciasv />} />
                <Route path="/prensa" element={<Prensa />} />
                <Route path="/reservas" element={<Reservas />} />
                <Route path="/admin" element={<AdminHome />} />
                <Route path="/admin/visitas" element={<AdminVisitas />} />
                <Route path="/admin/visitas/imprimir" element={<AdminDiaPrint />} />
                <Route path="/admin/obras" element={<AdminObras />} />
                <Route path="/admin/catalogo" element={<AdminCatalogo />} />
                <Route path="/encuesta/:bookingId" element={<Encuesta />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <FooterSwitcher />
          </div>
        </SmoothScroll>
        <Toaster
          position="bottom-center"
          toastOptions={{
            classNames: {
              toast: "!bg-paper-raised !border-line !text-ink !rounded-[3px] font-ui",
              title: "!font-ui !text-ink",
              description: "!text-ink-mute",
            },
          }}
        />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
